const CookiesExpirationMonths = 3;

export default CookiesExpirationMonths;